function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 156.4,
  y1: 189.64,
  x2: 186.86,
  y2: 136.58,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#0048aa"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: 72.53,
  y1: 211.1,
  x2: 118,
  y2: 178.81,
  xlinkHref: "#linear-gradient"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: 319.47,
  y1: 198.2,
  x2: 339.18,
  y2: 179.66,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#552800"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: 220.65,
  y1: 240.51,
  x2: 264.46,
  y2: 213.22,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#0071bc",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.99,
  stopColor: "#2e3192"
})));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "PP");

var _ref4 = /*#__PURE__*/React.createElement("polygon", {
  points: "341.47 66.96 274.65 27.07 274.65 83 341.47 120.79 341.47 66.96",
  fill: "#e1a621"
});

var _ref5 = /*#__PURE__*/React.createElement("line", {
  x1: 279.79,
  y1: 36.02,
  x2: 279.79,
  y2: 82.51,
  fill: "none",
  stroke: "#29abe2",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  x1: 291.34,
  y1: 43.24,
  x2: 291.34,
  y2: 89.73,
  fill: "none",
  stroke: "#29abe2",
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("line", {
  x1: 309.39,
  y1: 53.97,
  x2: 309.39,
  y2: 100.46,
  fill: "none",
  stroke: "#29abe2",
  strokeMiterlimit: 10
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  x1: 322.43,
  y1: 61.05,
  x2: 322.43,
  y2: 107.55,
  fill: "none",
  stroke: "#29abe2",
  strokeMiterlimit: 10
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  x1: 334.11,
  y1: 68.61,
  x2: 334.11,
  y2: 115.1,
  fill: "none",
  stroke: "#29abe2",
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M280.83,75.57s3-14.44,8.88-11.83c6.29,2.77.56,14.68,7.38,18.22,6.6,3.43,4.69-21.68,12.32-18.72,6.81,2.64,4.27,12.79,4.28,18,0,2.4-.81,11.27,3.85,12.63,8.16,2.38,4.78-22.07,15.29-16.52",
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10
});

var _ref11 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 280.83,
  cy: 75.67,
  rx: 1.28,
  ry: 1.55,
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 332.83,
  cy: 77.68,
  rx: 1.28,
  ry: 1.55,
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 303.67,
  cy: 68.61,
  rx: 1.28,
  ry: 1.55,
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 313.73,
  cy: 79.23,
  rx: 1.28,
  ry: 1.55,
  fill: "#fff"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M21.33,166.12,177.55,77.21a25.05,25.05,0,0,1,25,.13l161,93.75a13.92,13.92,0,0,1-.07,24.11L213.23,281.47a33.57,33.57,0,0,1-33.46,0L21.28,190.29A13.92,13.92,0,0,1,21.33,166.12Z",
  fill: "#3fc1c9"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M197.38,212.45c.09,0,56.32-29.21,56.39-29.16l-92.22-56.21-52.23-18.67L88.8,145C101.06,152.28,184.3,206.63,197.38,212.45Z",
  opacity: 0.32,
  fill: "url(#linear-gradient)"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M246.89,146.8s-.76,35.82-1.85,36.84-5.89-33-5.89-33",
  fill: "#844040"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M198.06,162c.85,2.43-2.07,49.78-.68,50.43s8.84-49.9,8.84-49.9",
  fill: "#844040"
});

var _ref19 = /*#__PURE__*/React.createElement("polyline", {
  points: "265.07 131.74 265.07 140.2 262.22 140.2 261.24 135.54",
  fill: "#a85c5c"
});

var _ref20 = /*#__PURE__*/React.createElement("polygon", {
  points: "98.42 104.95 98.42 96.64 101.92 101.24 98.42 104.95",
  fill: "#a85c5c"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M101.81,98.59,146.15,73a10.34,10.34,0,0,1,10.34,0L261.64,133.7a6.91,6.91,0,0,1,0,12l-44.42,25.64a9.89,9.89,0,0,1-9.89,0L101.81,110.39A6.81,6.81,0,0,1,101.81,98.59Z",
  fill: "#a85c5c"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M101.31,91l44.34-25.6a10.34,10.34,0,0,1,10.34,0l105.16,60.71a6.91,6.91,0,0,1,0,12l-44.42,25.64a9.89,9.89,0,0,1-9.89,0L101.31,102.84A6.81,6.81,0,0,1,101.31,91Z",
  fill: "#c96f6f"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M74.66,214.08c4.92,1.51,9.85,3,14.9,4a76.27,76.27,0,0,0,9.33,1.07l5.24-3.55,36.27-27-25.65-17.77L47,202.28C55.13,208.23,65.15,211.17,74.66,214.08Z",
  opacity: 0.32,
  fill: "url(#linear-gradient-2)"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M109.56,160c-3.65-2.55-8-3.95-12.59-2.93-4.95,1.09-9.23,4.2-14.27,5-.8.12-4-.08-4.47.38-14,13.27,25.18,11.85,25.18,11.85,3.81-3.12,7.39-6.18,11.17-9.33C113.44,162.34,111.52,161.34,109.56,160Z",
  fill: "#f8997c"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M91.11,179.21l-1.39,40.05c-.05,1.52,2.31,1.52,2.36,0l1.39-40.05C93.52,177.7,91.16,177.7,91.11,179.21Z",
  fill: "#844040"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M120.51,200.64Q109.8,190.16,100,178.76c-1-1.16-2.65.52-1.67,1.67q9.75,11.39,20.47,21.88C119.92,203.38,121.6,201.71,120.51,200.64Z",
  fill: "#844040"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M82.92,175.51q-8.32,15.7-15.66,31.87c-.62,1.37,1.41,2.57,2,1.19Q76.64,192.4,85,176.7C85.67,175.36,83.63,174.16,82.92,175.51Z",
  fill: "#844040"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M113.93,163.71a19,19,0,0,1-9.5,6.87c-5.36,1.61-13.15.85-16-4.67-5.13-10-.31-22.62-5.73-32.38a9.91,9.91,0,0,0-6.28-5.08c-3.51-.76-5.92,1.84-7.19,4.89-2.28,5.48-2.2,12.3-2.09,18.14a97.6,97.6,0,0,0,1,14.09s3.28,19.58,28.84,14.32a38.8,38.8,0,0,0,12.56-4.58,17.24,17.24,0,0,0,5.12-4.44C116.31,168.63,115.27,166,113.93,163.71Z",
  fill: "#e1a621"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M131.62,182.5s-.21,3.58.9,4.57,7.07-1.78,8.66-.79-6,8.14-8.66,8.54-5.14-3.4-5.14-3.4v5.39l-3,1.72-2.22-1.32.66-14.71Z",
  fill: "#8787d1"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M121.4,185.13c3.18,2.74,6.6,2.65,10.54,1,2.84-5,6.18-35.37-.92-40.23-7.62-5.21-19.52-4.28-21.51-3.72l-29.17,4.78C78.1,150.73,84,170.68,97,171.23s21.22-4.32,21.22-4.32Z",
  fill: "#124577"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M110.06,101.77a6.92,6.92,0,0,0-3.27,3l0,.1c-2.05,1.68-2.37,4.75-4.55,6.26,0,.06-2.05,1.5-2.07,1.56s.2-2.81.19-2.79v0c-.71,1.94-1.4,3.88-2,5.85a1.21,1.21,0,0,0,.31.14l-.23.11-.2.12a.66.66,0,0,1-.39.44,1.55,1.55,0,0,0,2.17,1.82l6.6-3.22a18.39,18.39,0,0,0,2.58-.75c0-.69.11-1.38.17-2.06a5.79,5.79,0,0,0,.44-5.46.62.62,0,0,1,.12-.12l0-.07a5,5,0,0,0,2.07-3.28C112.06,102.48,111.11,101.28,110.06,101.77Z",
  fill: "#f7931e"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M101.67,108s7.52,4.67,8.3,8.56c0,0-5.28,11.47-4.93,11.93,6,7.78-11.93-4.93-11.93-4.93S96.75,112.68,101.67,108Z",
  fill: "#e1a621"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M118.79,110.86c.62,5.19-6,12.43-8.8,13.82-3.83,1.91-5.32-14-22.15-13.94-1.09,0-6.55-2.32-9.42,4.85s0,27.74,1.91,31.32c1.69,3.16,12.91,10.76,28.93,2.63l.24-7.41S119,141.94,124,135c4.67-6.48,7.44-16.23,7-21C127.19,112.33,122.51,109.64,118.79,110.86Z",
  fill: "#e1a621"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M101.67,108s7.52,4.67,8.3,8.56c0,0-5.28,11.47-4.93,11.93,6,7.78-11.93-4.93-11.93-4.93S96.75,112.68,101.67,108Z",
  fill: "#8787d1"
});

var _ref35 = /*#__PURE__*/React.createElement("polyline", {
  points: "111.79 88.3 131.76 92.7 128.39 120.72 109.2 114.49",
  fill: "#124577"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M132.4,104.53a1.6,1.6,0,0,0-2.13-1.13,1.8,1.8,0,0,0-.64-1,1.61,1.61,0,0,0-1.82-.08,1.86,1.86,0,0,0-.46.38l-.1-.11a1.68,1.68,0,0,0-1.83-.5,1.57,1.57,0,0,0-.5.37,25.29,25.29,0,0,0-.71-2.71c-.27-.89-.71-2.53-1.81-2.73-.72-.13-1,.4-1.19,1a2,2,0,0,0-.07,1.34,14.35,14.35,0,0,0,.26,1.79c.1.84.19,1.69.27,2.54v0a.56.56,0,0,0-.4.16,3.06,3.06,0,0,0-1.08,3.46,26.42,26.42,0,0,0,2,5.11.58.58,0,0,0,.81.26l.08.31a.62.62,0,0,0,1.22-.07l0-.12a.59.59,0,0,0,.21.11l.05.68c0,.63,1,.63,1.19.11l.06.5c.08.69,1.18.62,1.22-.07l0-.56a.71.71,0,0,0,.53-.27.68.68,0,0,0,.44.25.57.57,0,0,0,.59.08l0,.15a.69.69,0,0,0,.81.46c0,.07,0,.14,0,.21,0,.79,1.24.89,1.23.1q0-2.36-.13-4.73a.59.59,0,0,0,.18-.14C131.92,108.43,133,106.31,132.4,104.53Zm-6.6-1.19a.4.4,0,0,1,.34-.05.69.69,0,0,0-.08.15h-.37A.51.51,0,0,1,125.8,103.34Z",
  fill: "#f7931e"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M96.75,91.8c0,.17,1,10.69-1.31,13s-8.61,1.36-10.16-1.17-3.46-5.87-1.8-9.79S96.47,89.21,96.75,91.8Z",
  fill: "#f7931e"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M93.38,98.64a1,1,0,0,0-.18-1.12,5.08,5.08,0,0,0-2.84-1.77,2.13,2.13,0,0,0-2.49,1.34c-.72,2.39,3.15,3.09,4.73,3.29a1.06,1.06,0,0,0,1.05-1.05A.94.94,0,0,0,93.38,98.64Z",
  fill: "#ffe8e6"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M118.79,110.86c.62,5.19-6,12.43-8.8,13.82-3.83,1.91-5.32-14-22.15-13.94-1.09,0-6.55-2.32-9.42,4.85s0,27.74,1.91,31.32c1.69,3.16,12.91,10.76,28.93,2.63l.24-7.41S119,141.94,124,135c4.67-6.48,7.44-16.23,7-21C127.19,112.33,122.51,109.64,118.79,110.86Z",
  fill: "#8787d1"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M117.47,140.32a20.73,20.73,0,0,1-24.28-8.06c-.34-.51-1.17,0-.83.48a21.69,21.69,0,0,0,25.36,8.5C118.3,141,118.05,140.11,117.47,140.32Z",
  fill: "#fff"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M108,122.91a15.41,15.41,0,0,0-3.73-5.27c-1.83-1.67-4.1-2.74-6-4.3-.38-.31-.94.23-.55.55,1.81,1.48,3.94,2.5,5.71,4a14.84,14.84,0,0,1,3.91,5.38C107.54,123.76,108.21,123.36,108,122.91Z",
  fill: "#fff"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M97,93.28,93.63,95s2.59,9.86,3.37,12.45-2.33,6.22-12.45,6.48-9.6-15-7.26-20.75,9.34-8.3,15-6.74A5.88,5.88,0,0,1,97,93.28Z",
  fill: "#b24d16"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M115.06,166a1.61,1.61,0,0,0-2.69-.48,18.08,18.08,0,0,1-7.94,5.05c-5.36,1.61-13.15.85-16-4.67-5.11-10-.35-22.52-5.67-32.28a10.76,10.76,0,0,0-4-4.25c-4.8-2.77-8,.26-9.53,4-2.28,5.48-2.2,12.3-2.09,18.14a97.6,97.6,0,0,0,1,14.09s3.28,19.58,28.84,14.32a38.8,38.8,0,0,0,12.56-4.58,17.24,17.24,0,0,0,5.12-4.44A5,5,0,0,0,115.06,166Z",
  fill: "#e1a621"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M315.52,202.31c2.8.86,5.61,1.7,8.49,2.28a43.48,43.48,0,0,0,5.32.61l3-2L353,187.8l-15.82-5.26-37.42,13C304.39,199,310.11,200.65,315.52,202.31Z",
  opacity: 0.32,
  fill: "url(#linear-gradient-3)"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M344.74,171.07c-3.73-.32-7.66-1.45-10.42-4v11.06a11.48,11.48,0,0,0,11.48,11.48h0a11.48,11.48,0,0,0,11.48-11.48V166.88C353.37,168.48,348.92,171.43,344.74,171.07Z",
  fill: "#e1a621"
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 345.8,
  cy: 166.99,
  rx: 11.48,
  ry: 6.09,
  fill: "#5ed18d"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M345.8,168s-7.81-1.15-9.87-13.78C335.93,154.25,342.59,157.92,345.8,168Z",
  fill: "#5ed18d"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M347,166.42s-9-16.07,0-26.87A45,45,0,0,1,347,166.42Z",
  fill: "#5ed18d"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M345.8,156.32s-7.81-1.15-9.87-13.78C335.93,142.54,342.59,146.21,345.8,156.32Z",
  fill: "#5ed18d"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M346.75,161.46s-2-7.65,8.9-14.43C355.65,147,354.83,154.6,346.75,161.46Z",
  fill: "#5ed18d"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 345.8,
  cy: 166.99,
  rx: 11.48,
  ry: 6.09,
  fill: "#146666"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M345.8,168s-7.81-1.15-9.87-13.78C335.93,154.25,342.59,157.92,345.8,168Z",
  fill: "#5ed18d"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M347,166.42s-9-16.07,0-26.87A45,45,0,0,1,347,166.42Z",
  fill: "#5ed18d"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M345.8,156.32s-7.81-1.15-9.87-13.78C335.93,142.54,342.59,146.21,345.8,156.32Z",
  fill: "#5ed18d"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M346.75,161.46s-2-7.65,8.9-14.43C355.65,147,354.83,154.6,346.75,161.46Z",
  fill: "#5ed18d"
});

var _ref56 = /*#__PURE__*/React.createElement("polyline", {
  points: "241.17 133.9 241.17 134.84 240.7 135.42",
  fill: "#adcee1"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M222.26,122.44l18.38,11.39a1.14,1.14,0,0,1,0,2l-27.89,15.78a2.55,2.55,0,0,1-2.55,0l-18.3-10.75c-1.33-1.09-1.23-3.15,0-3.23l27.73-15.16A2.59,2.59,0,0,1,222.26,122.44Z",
  fill: "#88d3d8"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M222.26,121.65,240.64,133a1.14,1.14,0,0,1,0,2l-27.89,15.78a2.55,2.55,0,0,1-2.55,0L191.86,140a1.42,1.42,0,0,1,0-2.45l27.73-15.94A2.59,2.59,0,0,1,222.26,121.65Z",
  fill: "#fff"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M221.51,120.1s-7.63-24.63-7.58-24.63-.24-1.09-1.6-.48L183,112.23s-1.42.58-1.14,1.9,7.46,24.1,7.46,24.1a1.24,1.24,0,0,0,1.38.48c.89-.28,30.09-17.24,30.09-17.24A1.12,1.12,0,0,0,221.51,120.1Z",
  fill: "#053855"
});

var _ref60 = /*#__PURE__*/React.createElement("polygon", {
  points: "213.44 97.25 183.44 114.74 189.66 135.63 220.04 118.66 213.44 97.25",
  fill: "#e1a621"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M223.39,124.26l6.72,4.19a.81.81,0,0,1,0,1.39L206,143.59a2.37,2.37,0,0,1-2.37,0c-1.55-.9-4.22-2.53-5.85-3.53a1,1,0,0,1,0-1.69L222,124.24A1.31,1.31,0,0,1,223.39,124.26Z",
  fill: "#e1a621"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M223,135.62l-8.43,4.74a.84.84,0,0,0,0,1.46l5,2.9a1.12,1.12,0,0,0,1.12,0l8.62-4.92a.7.7,0,0,0,0-1.22l-5.15-3A1.12,1.12,0,0,0,223,135.62Z",
  fill: "#e1a621"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M223.39,124.26l6.72,4.19a.81.81,0,0,1,0,1.39L206,143.59a2.37,2.37,0,0,1-2.37,0c-1.55-.9-4.22-2.53-5.85-3.53a1,1,0,0,1,0-1.69L222,124.24A1.31,1.31,0,0,1,223.39,124.26Z",
  fill: "#053855",
  opacity: 0.1
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M223,135.62l-8.43,4.74a.84.84,0,0,0,0,1.46l5,2.9a1.12,1.12,0,0,0,1.12,0l8.62-4.92a.7.7,0,0,0,0-1.22l-5.15-3A1.12,1.12,0,0,0,223,135.62Z",
  fill: "#053855",
  opacity: 0.1
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M231.11,248.83c15.31-9.17,42.87-25.21,46.55-28.52l-.88-3.24L256.1,204.8l-50.35,29.26C212.88,240.07,223.38,243.57,231.11,248.83Z",
  opacity: 0.41,
  fill: "url(#linear-gradient-4)"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M248,92.53l-4.39-3.29a.88.88,0,0,0-.41-.7q-6.29-4.38-12.56-8.8a1,1,0,0,0-1.58.55c-.44.76.12,1.55.83,2.14s1.59,1.31,2.39,2a1,1,0,0,0-.26.28c-.64,1-1.71,2.42-1.72,3.67s1,1.87,1.78,2.55l0,.18c-.16,1.54.52,2,1.74,2.73a1,1,0,0,0,.81.14,17.12,17.12,0,0,0,2.67,1.42l3.7,1.88c.94.48,1.62-.65,1.24-1.41.74.06,1.05-.75.86-1.38a.85.85,0,0,0,.21-.33l0-.05,1.28,1c1,.81,2.26-.8,1.23-1.61l-.91-.72,1.87,1.4A1,1,0,0,0,248,92.53Z",
  fill: "#f04900"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M277,221.12l1.58-1,0-17.79-7.81-.28s-.15,7.59-2,9.32-6.41.49-6.86.64-3.52-.74-4.9.68,4.68,5.52,7.9,6.27a20.8,20.8,0,0,0,6.7.25s.7-4.55,1.82-4.1,1.2,5.26,1.2,5.26Z",
  fill: "#006ba4"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M282.92,126.94a126.26,126.26,0,0,1,1.94,18.49c.13,7-2.34,62.94-2.34,62.94s-4.64,5.44-15.94,2.16c-1.64-.47-2.16-54.59-2.16-54.59l3.86-24.84",
  fill: "#fc9c54"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M277.73,98.69c-.62,0-21.41-.54-35.46-13.13,0,0-6.73,6.6-4,11.65,0,0,19.92,19.19,35.11,15.26",
  fill: "#006ba4"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M261.26,92.75a.31.31,0,0,0-.52,0,13.72,13.72,0,0,0-2,10.29c.08.38.66.22.59-.16A13.09,13.09,0,0,1,261,93.51a21.64,21.64,0,0,1,2.56,10.4.3.3,0,0,0,.61,0A22.29,22.29,0,0,0,261.26,92.75Z",
  fill: "#42a200"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M255.65,234.85l1.58-1,0-17.79-7.81-.28s-.15,7.59-2,9.32-6.41.49-6.86.64-3.52-.74-4.9.68,4.68,5.52,7.9,6.27a20.8,20.8,0,0,0,6.7.25s.7-4.55,1.82-4.1,1.2,5.26,1.2,5.26Z",
  fill: "#006ba4"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M258.45,129.53s-7.2,26.58-10.13,50.37c-.7,5.71-6.61,39.77-6.61,39.77s9.74,3.56,18.4.77c0,0,10.3-43.46,10.74-44.31s7.39-29,8.19-49.2",
  fill: "#fc9c54"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M280.46,95.71l-4.11-1.55c-1.05.07-10.4,3.13-14.65,9.32a40.52,40.52,0,0,0-1.36,5.93c-.54,2.67-1,5.35-1.34,8a59.2,59.2,0,0,0-.5,8.86c0,1.27.07,1.91.2,3.17a5.61,5.61,0,0,0,1.58,1.12c12.28,5.28,22-1.13,22.49-2.12s2.11-15.47,3-24.09A8.34,8.34,0,0,0,280.46,95.71Z",
  fill: "#006ba4"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M270.43,79.94s-3.86,14,1.27,15.93,11.73-3.57,12.39-6.46S278.13,75.73,270.43,79.94Z",
  fill: "#f04900"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M295.77,75.76A6.52,6.52,0,0,0,288,72.32c-2.83.92-4.54,3.35-5.37,6.06-2.55-2.23-6.35-3.36-11.17-1.88,0,0-4.73,2-3.87,5s4.45,3,7.46,3.59.57,3.23.72,6.2,1.49,3.46,2.74,3.72,6.93-1,7.73-7.67a8.89,8.89,0,0,0,.06-1.23,15.92,15.92,0,0,0,2.35.07,8.73,8.73,0,0,0,5-1.38A7.58,7.58,0,0,0,295.77,75.76Z",
  fill: "#fc9c54"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M265.49,95.29a2.67,2.67,0,0,0,.47-1.9,1,1,0,0,0-1.82-.42l-.44.6c-.07-.77-.15-1.54-.26-2.31a1,1,0,0,0-2,.07c0,.24-.06.49-.08.73a4,4,0,0,0-.17.79c-1.09.14-2.39.54-2.58,1.79,0,0,0,.06,0,.08-.84,0-1.66.33-1.69,1.33a3.68,3.68,0,0,0,0,.57c-.85.25-1.47.68-1.35,1.79a16.34,16.34,0,0,0,1,3.77,1,1,0,0,0,.76.57c.12.54.26,1.07.41,1.6a1.5,1.5,0,0,0,2.52.28,1.18,1.18,0,0,0,.3-.06,1,1,0,0,0,.83.14,1,1,0,0,0,1.51-.45,1,1,0,0,0,.33-.84c0-.23,0-.46,0-.68v0Q264.43,99,265.49,95.29Z",
  fill: "#f04900"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M263.78,100.47c-.32.08-4.82-4.05-8.23-2.63,0,0-13,21.92-.87,27.72,6,2.88,10.67-6,10.67-6l-3.45-6.82Z",
  fill: "#006ba4"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M262.71,101.36a43.8,43.8,0,0,0-5.78,15.16c-.11.63.85.9,1,.27a43,43,0,0,1,5.68-14.92C263.9,101.32,263,100.82,262.71,101.36Z",
  fill: "#653200"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M265.12,120.41c-1,1.95-2.28,4-4.28,5a6.56,6.56,0,0,1-7.23-1.12c-4.26-3.67-3.62-10-2.77-14.93.11-.63-.85-.9-1-.27-1,5.54-1.51,12.74,3.72,16.45a7.52,7.52,0,0,0,7.09,1c2.5-1,4.09-3.38,5.29-5.69C266.28,120.34,265.42,119.84,265.12,120.41Z",
  fill: "#653200"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M276,146.49c-.64,12.71-4.39,24.89-7.57,37.13s-5.89,24.43-8.21,36.78l1.08-.3q3.53-18.71,8.34-37.15c3.15-12,6.73-24,7.36-36.46C277.05,145.85,276.05,145.85,276,146.49Z",
  fill: "#653200"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M152.58,91.72l-11.88-7s3-2.3,4.69-1.5a7,7,0,0,1,1.93,1.11s1.22-2.53,3.35-2a3.62,3.62,0,0,1,2.64,2s.92-2.38,3-1.11a4.93,4.93,0,0,1,2.26,3.57L158.35,95Z",
  fill: "#fff"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M167.66,93.11l11.88-7s-3-2.3-4.69-1.5a7,7,0,0,0-1.93,1.11s-1.22-2.53-3.35-2a3.62,3.62,0,0,0-2.64,2s-.92-2.38-3-1.11a4.93,4.93,0,0,0-2.26,3.57l.23,8.24Z",
  fill: "#fff"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M165.7,73.68s4.38,4.52,4.38,7.1,0,10.93,0,10.93h-1.83s-3.75-8.61-6.14-11.44S165.7,73.68,165.7,73.68Z",
  fill: "#e1a621"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M165.7,73.68s4.38,4.52,4.38,7.1,0,10.93,0,10.93h-1.83s-3.75-8.61-6.14-11.44S165.7,73.68,165.7,73.68Z",
  fill: "#363636",
  opacity: 0.61
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M154.72,73.68s-4.38,4.52-4.38,7.1,0,10.93,0,10.93h1.83s3.75-8.61,6.14-11.44S154.72,73.68,154.72,73.68Z",
  fill: "#e1a621"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M154.72,73.68s-4.38,4.52-4.38,7.1,0,10.93,0,10.93h1.83s3.75-8.61,6.14-11.44S154.72,73.68,154.72,73.68Z",
  fill: "#363636",
  opacity: 0.61
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M164.51,43.45a38,38,0,0,0-4.18-8.15,36.64,36.64,0,0,0-4.15,8.22C158.65,44.84,161.75,44.42,164.51,43.45Z",
  fill: "#e1a621"
});

var _ref88 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 160.21,
  cy: 61.83,
  rx: 4.45,
  ry: 3.92,
  fill: "#e1a621"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M160.33,35.29s-13.2,17.83-4.42,45.44c0,0,1,5.89,4.12,5.77S165.59,80,165.59,80,172.77,53.55,160.33,35.29Z",
  fill: "#e1a621"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M164.51,43.45a38,38,0,0,0-4.18-8.15,36.64,36.64,0,0,0-4.15,8.22C158.65,44.84,161.75,44.42,164.51,43.45Z",
  fill: "#363636",
  opacity: 0.61
});

var _ref91 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 160.21,
  cy: 61.83,
  rx: 4.45,
  ry: 3.92,
  fill: "#363636",
  opacity: 0.61
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  d: "M155.91,80.73s-3,3.12-3,4.89,0,7.53,0,7.53h1.26s2.59-5.93,4.23-7.88S155.91,80.73,155.91,80.73Z",
  fill: "#e1a621"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M164.51,80.73s3,3.12,3,4.89,0,7.53,0,7.53h-1.26s-2.59-5.93-4.23-7.88S164.51,80.73,164.51,80.73Z",
  fill: "#e1a621"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M155.91,80.73s-3,3.12-3,4.89,0,7.53,0,7.53h1.26s2.59-5.93,4.23-7.88S155.91,80.73,155.91,80.73Z",
  fill: "#363636",
  opacity: 0.29
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M164.51,80.73s3,3.12,3,4.89,0,7.53,0,7.53h-1.26s-2.59-5.93-4.23-7.88S164.51,80.73,164.51,80.73Z",
  fill: "#363636",
  opacity: 0.29
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M158.87,85.91s-5.13.89-6,3a4.88,4.88,0,0,0-.22,3.55s-3.24.1-3.82,2.34,0,2.95,0,2.95-7.23.29-7,7.59v2.34l17.05-9.84Z",
  fill: "#fff"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M161.32,85.24s5.13.89,6,3a4.88,4.88,0,0,1,.22,3.55s3.24.1,3.82,2.34,0,2.95,0,2.95,7.23.29,7,7.59V107l-17.05-9.84Z",
  fill: "#fff"
});

var SvgStartup = function SvgStartup(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 400 300",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStartup, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/startup.8f234713.svg";
export { ForwardRef as ReactComponent };